export const baseURL = "https://prodapi.babytuesday.link";
// export const baseURL = "https://devapi.babytuesday.link";

export const ERROR_TEXT =
  "Thank you for submitting your information. This link is not valid once the event begins. However, we added your name to the event's guest list. Thanks!";

export const POPUP_ERROR_TEXT =
  "Thank you for submitting your information.\nThis link is not valid once the event begins.\nHowever, we added your name to the event's guest list.\nThanks!";
